/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const CardBase = (props) => {
  const {
    children,
    title,
    subtitle,
    Buttons,
    shadedOutline,
    noPadding,
    sizeTitle,
    intereactionDisabled,
  } = props;

  const isMobile =
    /Android/i.test(navigator.userAgent) ||
    /webOS/i.test(navigator.userAgent) ||
    /iPhone/i.test(navigator.userAgent) ||
    /iPad/i.test(navigator.userAgent) ||
    /iPod/i.test(navigator.userAgent) ||
    /BlackBerry/i.test(navigator.userAgent) ||
    /Windows Phone/i.test(navigator.userAgent);

  return (
    <section
      className={`CardBase
        ${shadedOutline ? ' CardBase--shaded' : ''}
        ${Buttons ? ' CardBase--action-button' : ''}
        ${intereactionDisabled ? ' CardBase--disabled' : ''}
        ${isMobile ? ' CardBase--mobile' : ''}
      `}
    >
      <header>
        <article className='CardBase--titles'>
          {title && !sizeTitle && <h2>{title}</h2>}
          {title && sizeTitle && (
            <h2 className={`CardBase__title--${sizeTitle}`}>{title}</h2>
          )}
          {subtitle && <h4>{subtitle}</h4>}
        </article>
        {Buttons}
      </header>

      {children && <hr />}

      {children && (
        <article
          className={`CardBase_content${noPadding ? '--no-padding' : ''}`}
        >
          {children}
        </article>
      )}
    </section>
  );
};

CardBase.defaultProps = {
  title: '',
  subtitle: '',
  sizeTitle: false,
  children: <></>,
  Buttons: <></>,
  shadedOutline: false,
  noPadding: false,
  intereactionDisabled: false,
};

CardBase.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  sizeTitle: PropTypes.bool,
  children: PropTypes.element,
  Buttons: PropTypes.element,
  shadedOutline: PropTypes.bool,
  noPadding: PropTypes.bool,
  intereactionDisabled: PropTypes.bool,
};

export default CardBase;